export interface IUserInvitationResponse {
  FromName?: string
  EventTitle?: string
  ApplicationUserID?: string
  TransferOwnership?: boolean
  Name: string
  Email: string
}

export class UserInvitation {
  public fromName?: string
  public eventTitle?: string
  public applicationUserId?: string
  public transferOwnership?: boolean
  public name?: string
  public email?: string

  constructor(invitation: Partial<UserInvitation>) {
    this.fromName = invitation.fromName
    this.eventTitle = invitation.eventTitle
    this.applicationUserId = invitation.applicationUserId
    this.transferOwnership = invitation.transferOwnership
    this.name = invitation.name
    this.email = invitation.email
  }

  public static fromResponse(response?: IUserInvitationResponse) {
    return new UserInvitation({
      fromName: response?.FromName,
      eventTitle: response?.EventTitle,
      applicationUserId: response?.ApplicationUserID,
      transferOwnership: response?.TransferOwnership ?? false,
      name: response?.Name,
      email: response?.Email,
    })
  }
}
